window.copyStarterDiscountCode = async function (code) {
  navigator.permissions
    .query({ name: 'clipboard-write' })
    .then(async (result) => {
      if (result.state == 'granted' || result.state == 'prompt') {
        await navigator.clipboard.writeText(code);
        const copyStarterDiscountCodeButton = document.getElementById(
          'copy-starter-discount-code',
        );
        const copyStarterDiscountCodeDone = document.getElementById(
          'copy-starter-discount-code-done',
        );
        copyStarterDiscountCodeButton.classList.add('!hidden');
        copyStarterDiscountCodeDone.classList.remove('!hidden');
        setTimeout(function () {
          copyStarterDiscountCodeButton.classList.remove('!hidden');
          copyStarterDiscountCodeDone.classList.add('!hidden');
        }, 3000);
      }
    });
};
